import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useClient } from '../../client-api';
import { type SurplusPanelSettingsDto, type SurplusPanelSettingsUpdateDto, updateSurplusPanel } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export const useUpdateSurplusOverride = (): UseMutationResult<SurplusPanelSettingsDto, AxiosError, SurplusPanelSettingsUpdateDto> => {
    const queryClient = useQueryClient();
    const { data: client } = useClient();

    return useMutation({
        mutationFn: (payload) => updateSurplusPanel({ body: payload, path: { id: payload.id! } }).then((result) => result.data!),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.surplusPanelSettings(client?.partnerUuid) });
            queryClient.invalidateQueries({ queryKey: queryKeys.cashFlow(client?.partnerUuid) });
            queryClient.invalidateQueries({ queryKey: queryKeys.projection(client?.partnerUuid) });
        },
    });
};
